module.exports = __webpack_public_path__ + "static/media/avril-lavigne-lose.914e36ef.jpg";